// extracted by mini-css-extract-plugin
export default {"userChangeEmail":"UserChangeEmail_userChangeEmail__nDyEV","emailCardWrapper":"UserChangeEmail_emailCardWrapper__BzZ6F"};